import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, IconButton, TextField, Box, Typography,
  CircularProgress, Alert, Tooltip,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close'
import { useState } from 'react'
import Swal from 'sweetalert2'
import { useAppServices } from 'hook/services'

export default function EditLinkModal({ post, handleRefresh }) {
  const [open, setOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [linkUrl, setLinkUrl] = useState(post.linkUrl || '')
  const [caption, setCaption] = useState(post.caption || '')
  const AppService = useAppServices()

  const handleOpen = () => {
    setLinkUrl(post.linkUrl || '')
    setCaption(post.caption || '')
    setError('')
    setOpen(true)
  }

  const handleSave = async () => {
    setSaving(true)
    setError('')
    const res = await AppService.linkinbio.update({
      payload: { mediaId: post.mediaId, linkUrl, caption },
    })
    setSaving(false)
    if (res?.error) {
      setError(res.error.message || 'Failed to update.')
      return
    }
    setOpen(false)
    handleRefresh()
    Swal.fire({ icon: 'success', title: 'Updated!', timer: 1500, showConfirmButton: false })
  }

  return (
    <>
      <Tooltip title="Edit link">
        <IconButton
          size="small"
          onClick={handleOpen}
          sx={{ color: '#f57c00', '&:hover': { backgroundColor: '#fff3e0' } }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: '16px' } }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #1A73E8 0%, #0D47A1 100%)',
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 2,
            px: 3,
          }}
        >
          <Typography variant="h6" fontWeight={700} style={{ color: 'white' }} fontSize="1rem">
            Edit Post Link
          </Typography>
          <IconButton onClick={() => setOpen(false)} sx={{ color: 'white' }} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 4, py: 3 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2, borderRadius: '8px' }}>
              {error}
            </Alert>
          )}

          <Box display="flex" flexDirection="column" gap={2} mt={2}>
            <TextField
              label="Link URL"
              fullWidth
              value={linkUrl}
              onChange={(e) => setLinkUrl(e.target.value)}
              placeholder="https://aloca.com.au/listing/..."
            />

            <TextField
              label="Caption"
              fullWidth
              multiline
              minRows={3}
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 4, pb: 3, gap: 1 }}>
          <Button onClick={() => setOpen(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={saving}
            sx={{ borderRadius: '8px', textTransform: 'none', background: 'linear-gradient(135deg, #1A73E8, #0D47A1)' }}
            style={{ color: 'white' }}
          >
            {saving ? <CircularProgress size={16} color="inherit" /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
